export default "__VITE_ASSET__CnjCRMiL__"